/**
 * Theme Requirements Aggregation for Rebel Residential
 * 
 * Extends the base prestige theme requirements with Rebel Residential specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-prestige/requirements';

/**
 * Rebel Residential component requirement overrides.
 * Add requirements for any override components here.
 */
const rebelresidentialOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Rebel Residential theme.
 * Inherits from prestige theme and overrides with Rebel Residential components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...rebelresidentialOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
